import AbstractNode from './AbstractNode';
import {TextSelection} from 'prosemirror-state';

export default class Card extends AbstractNode {
    get name() {
        return "card";
    }

    get schema() {
        return {
            content: "card_content card_content_extra?",
            group: "block",
            selectable: true,
            draggable: true,
            parseDOM: [{
                tag: '.ui.card'
            }],
            toDOM: () => ["div", {'class': 'ui raised centered card'}, 0]
        }
    }

    toMarkdown(state, node) {
        state.flushClose(2);

        if (node.taskListColumn) {
          state.write('<div class="hidden draggable ui raised link centered card" data-workflow-id="${swf:workflowId}" data-task-id="${swf:taskId}">');
        } else {
          state.write('<div class="ui raised centered card">');
        }

        state.ensureNewLine();
        state.renderContent(node);

        state.write('</div>');

        state.ensureNewLine();
        state.closeBlock(node);
    }

    get parseMarkdown() {
        return {
            block: "card"
        }
    }

    commands({schema}) {
        return {
            createCard: () => view => {
                const offset = view.state.tr.selection.anchor + 1;
                const tr = view.state.tr.replaceSelectionWith(schema.nodes.card.createAndFill({}, [
                  schema.nodes.card_content.createAndFill({}, [
                      schema.nodes.card_content_header.createAndFill(),
                      schema.nodes.card_content_meta.createAndFill(),
                      schema.nodes.card_content_description.createAndFill()
                  ]),
                  schema.nodes.card_content_extra.createAndFill(),
                ])).scrollIntoView();
                const resolvedPos = tr.doc.resolve(offset);
                view.dispatch(tr.setSelection(TextSelection.near(resolvedPos)));
            }
        };
    }
}